import { Box, Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { StyledButton } from '../components/ui';
import { LegalPageLayout } from '../layouts';

/**
 * 404 Not Found page component
 *
 * @returns {JSX.Element} 404 error page
 */
function NotFound() {
  const navigate = useNavigate();

  return (
    <LegalPageLayout>
      <Box
        sx={{
          minHeight: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          py: 8,
        }}
      >
        <Container maxWidth="md">
          <Box sx={{ textAlign: 'center' }}>
            {/* 404 Number */}
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '6rem', sm: '8rem', md: '10rem' },
                fontWeight: 900,
                color: 'var(--color-primary)',
                lineHeight: 0.8,
                mb: 2,
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                textShadow: '0 4px 8px rgba(0,0,0,0.1)',
              }}
            >
              404
            </Typography>

            {/* Error Message */}
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem' },
                fontWeight: 600,
                color: 'var(--color-heading)',
                mb: 2,
                fontFamily: '"Playfair Display", serif',
              }}
            >
              Page Not Found
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: '1.125rem',
                color: 'var(--color-text-muted)',
                mb: 4,
                maxWidth: '500px',
                mx: 'auto',
                lineHeight: 1.6,
              }}
            >
              The page you're looking for doesn't exist or has been moved. Let's
              get you back to exploring our solutions.
            </Typography>

            {/* Action Buttons */}
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                justifyContent: 'center',
                flexWrap: 'wrap',
              }}
            >
              <StyledButton
                variant="contained"
                size="large"
                onClick={() => navigate('/')}
                sx={{ minWidth: '160px' }}
              >
                Go Home
              </StyledButton>

              {/* <StyledButton
              variant="outlined"
              size="large"
              onClick={() => navigate('/blog')}
              sx={{
                minWidth: '160px',
                borderColor: 'var(--color-primary)',
                color: 'var(--color-primary)',
                '&:hover': {
                  backgroundColor: 'color-mix(in srgb, var(--color-primary) 10%, transparent)',
                  borderColor: 'var(--color-primary)',
                },
              }}
            >
              Browse Insights
            </StyledButton> */}
            </Box>

            {/* Helpful Links */}
            <Box
              sx={{ mt: 6, pt: 4, borderTop: '1px solid var(--color-border)' }}
            >
              <Typography
                variant="h6"
                sx={{ mb: 2, color: 'var(--color-heading)' }}
              >
                Looking for something specific?
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 3,
                  flexWrap: 'wrap',
                }}
              >
                <Typography
                  component="button"
                  onClick={() => navigate('/#collective')}
                  sx={{
                    color: 'var(--color-primary)',
                    textDecoration: 'underline',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    '&:hover': { color: 'var(--color-primary-dark)' },
                  }}
                >
                  Our Community
                </Typography>

                <Typography
                  component="button"
                  onClick={() => navigate('/#services')}
                  sx={{
                    color: 'var(--color-primary)',
                    textDecoration: 'underline',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    '&:hover': { color: 'var(--color-primary-dark)' },
                  }}
                >
                  RSMC Solutions & Services
                </Typography>

                <Typography
                  component="button"
                  onClick={() =>
                    window.location.assign('/lets-collaborate#form')
                  }
                  sx={{
                    color: 'var(--color-primary)',
                    textDecoration: 'underline',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '1rem',
                    '&:hover': { color: 'var(--color-primary-dark)' },
                  }}
                >
                  Let's Collaborate
                </Typography>
              </Box>
            </Box>
          </Box>
        </Container>
      </Box>
    </LegalPageLayout>
  );
}

export default NotFound;
